"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.991 16.617q.117-.232.25-.49c.58-1.119 1.335-2.579 1.335-4.241C19.576 7.544 16.103 4 11.788 4S4 7.544 4 11.886c0 4.341 3.473 7.885 7.788 7.885a7.7 7.7 0 0 0 3.192-.69c.637.43 1.273.713 1.93.84.846.166 1.641.056 2.409-.202a1 1 0 0 0-.073-1.917c-.732-.186-1.093-.454-1.235-.644-.092-.124-.14-.268-.02-.541m-1.039 2.29c-.59-.143-1.202-.46-1.875-.996a6.7 6.7 0 0 1-3.29.86C8.04 18.772 5 15.69 5 11.887S8.039 5 11.788 5s6.788 3.083 6.788 6.886c0 1.398-.626 2.616-1.208 3.75q-.144.279-.281.553c-.31.682-.182 1.304.32 1.789.352.342.891.615 1.593.793-.696.235-1.358.304-2.048.137"
}), 'BubbleHelp');
